import { useTranslations } from '@lang';
import { useWizardNavigation } from '../../contexts';

export const useNextStepLabel = () => {
  const { t } = useTranslations();
  const { isLastStep } = useWizardNavigation();

  return isLastStep ? t('product.ctaButton') : t('spa.package.nextStep');
};
